import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Reveal from "./Reveal";

const FAQ_ITEMS = [
  {
    q: "What is your minimum order quantity (MOQ)?",
    a: "MOQs vary by category and product — typically starting from small trial orders for new buyers, scaling to container loads for established partners. Contact us for category-specific MOQs.",
  },
  {
    q: "Can you provide product samples before bulk orders?",
    a: "Yes, we coordinate sample requests directly with suppliers. Sample costs and shipping are typically borne by the buyer unless otherwise negotiated.",
  },
  {
    q: "Do you offer private label / custom branding?",
    a: "Yes, across most categories we can arrange custom labels, tags, packaging, and branding per your specifications, subject to MOQ requirements.",
  },
  {
    q: "What shipping terms do you support?",
    a: "We support FOB, CIF, DDP, and EXW Incoterms. Our team can recommend the best option based on your destination and order volume.",
  },
  {
    q: "How long does production and shipping take?",
    a: "Lead times vary by category and order size — typically 2–6 weeks for production plus shipping transit time (sea freight: 3–6 weeks depending on destination).",
  },
  {
    q: "Do you handle export documentation?",
    a: "Yes — we prepare invoices, packing lists, certificates of origin, and other documentation required for customs clearance at destination.",
  },
];

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <div className="border-b border-border last:border-b-0">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 py-5 text-left group"
        aria-expanded={isOpen}
      >
        <span className="font-medium text-primary group-hover:text-accent transition-colors pr-2">
          {item.q}
        </span>
        <ChevronDown
          size={20}
          className={`shrink-0 text-muted transition-transform duration-300 ${
            isOpen ? "rotate-180 text-accent" : ""
          }`}
        />
      </button>
      <div
        className="overflow-hidden transition-[max-height] duration-300 ease-in-out"
        style={{ maxHeight: isOpen ? "240px" : "0px" }}
      >
        <p className="pb-5 text-sm text-muted leading-relaxed pr-8">{item.a}</p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="section-shell bg-bg">
      <div className="section-inner">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary tracking-tight">
              Frequently Asked Questions
            </h2>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="max-w-3xl mx-auto bg-surface border border-border rounded-2xl px-5 md:px-8 shadow-sm">
            {FAQ_ITEMS.map((item, i) => (
              <FaqItem
                key={item.q}
                item={item}
                isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
